import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) { config.headers = config.headers || {}; config.headers.Authorization = `Bearer ${token}`; }
  return config;
});

export async function getOpportunity(params = {}) {
  const { data } = await client.get('/electoral/opportunity', { params });
  return data;
}
export async function setCircuitoBarrio(circuito, barrio) {
  const { data } = await client.post('/electoral/set-barrio', { circuito, barrio });
  return data;
}
export async function listBarriosElectoral() {
  const { data } = await client.get('/territory/barrios');
  return data.barrios || [];
}
export async function loadElectoral(payload) {
  // payload: { eleccion, rows: [{ circuito, seccion?, electores?, votos_total?, resultados:{FUERZA:votos}, barrio? }] }
  const { data } = await client.post('/electoral/load', payload);
  return data;
}
